module.exports = __webpack_public_path__ + "img/network-error-icon.68b42792.png";